import { ColumnFiltersState } from '@tanstack/react-table';

// src/utils/table/tableUtils.ts
export const getUniqueValues = <T extends object>(
  data: T[],
  key: string,
  // TODO: Remove this once we have a proper type for the object
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Record<string, any>
): string[] => {
  let filtered = data;

  // Apply existing filters
  Object.entries(filters).forEach(([filterKey, filterValue]) => {
    if (filterKey !== key && filterValue) {
      filtered = filtered.filter((item) => {
        // TODO: Remove this once we have a proper type for the object
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const val = filterKey.split('.').reduce<any>((o, k) => (o ? o[k] : undefined), item);
        if (Array.isArray(filterValue)) {
          return filterValue.includes(val);
        }
        return val?.toLowerCase().includes(String(filterValue).toLowerCase());
      });
    }
  });

  // Get unique values
  const unique = Array.from(
    new Set(
      // TODO: Remove this once we have a proper type for the object
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      filtered.map((item) => key.split('.').reduce<any>((o, k) => (o ? o[k] : undefined), item))
    )
  );

  return unique.filter(Boolean);
};

// Helpers para obtener valores únicos de cada columna según los filtros actuales
export const getUniqueValuesForColumn = <T extends object>(
  key: string,
  columnFilters: ColumnFiltersState,
  data: T[]
) => {
  // Transform columnFilters to the format expected by getUniqueValues
  const filters = columnFilters.reduce(
    (acc, filter) => {
      acc[filter.id] = filter.value;
      return acc;
    },
    // TODO: Remove this once we have a proper type for the object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {} as Record<string, any>
  );

  return getUniqueValues(data, key, filters);
};
